import { Action, CallAction, PHONE_HREF } from "./primitives";
import { SiteShell } from "./SiteShell";

export function NotFoundPage() {
  return (
    <SiteShell>
      <section
        id="top"
        className="hero-glow blueprint-light relative overflow-hidden bg-ink pt-32 md:pt-40"
      >
        <div className="relative z-10 mx-auto max-w-[1240px] px-6 pb-28 pt-10 lg:pb-36">
          <span className="eyebrow inline-block max-w-full rounded-full border border-foam/40 bg-foam/10 px-4 py-2 text-foam">
            404
          </span>
          <h1 className="mt-7 max-w-[16ch] text-[2.8rem] text-on-ink sm:text-6xl lg:text-[4.6rem]">
            Wrong turn — let&rsquo;s get you <em className="not-italic text-foam">back</em>
          </h1>
          <p className="mt-7 max-w-xl text-lg leading-relaxed text-on-ink-muted">
            That page isn&rsquo;t here. Head home, or{" "}
            <a href={PHONE_HREF} className="font-bold text-foam">
              call Gary
            </a>{" "}
            and we&rsquo;ll get you pointed in the right direction.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Action href="/" arrow>
              Back Home
            </Action>
            <CallAction variant="ghostLight" />
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
